import { render } from "./SdFileImporter.html?vue&type=template&id=47168207&ts=true&external"
import script from "./SdFileImporter.ts?vue&type=script&lang=ts&external"
export * from "./SdFileImporter.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__